import { createReducer } from 'reduxsauce';
import initialState from './model';

import paginationReduxHandlers, {
    types as paginationTypes,
    actions as paginationActions,
} from './pagination/reducer';

import createReduxHandlers, {
    types as createTypes,
    actions as createActions,
} from './create/reducer';

import viewReduxHandlers, {
    types as viewTypes,
    actions as viewActions,
} from './view/reducer';

import deleteReduxHandlers, {
    types as deleteTypes,
    actions as deleteActions,
} from './delete/reducer';

const types = {
    ...paginationTypes,
    ...createTypes,
    ...viewTypes,
    ...deleteTypes,
};

const actions = {
    ...paginationActions,
    ...createActions,
    ...viewActions,
    ...deleteActions,
};

export { types, actions };

export default createReducer(initialState, {
    ...paginationReduxHandlers,
    ...createReduxHandlers,
    ...viewReduxHandlers,
    ...deleteReduxHandlers,
});
